import { AGENCY_CREDIT, BRAND, PRIVACY_POLICY_PATH, SOCIAL_LINKS } from '../../core/constants/site';
import BrandMark from '../../common/components/BrandMark/BrandMark';

import CHANGELOG from './changelog';

import './styles/site-footer.css';

const CURRENT_VERSION = CHANGELOG[0].version;
const FOOTER_SOCIAL_IDS = ['instagram', 'facebook', 'youtube'];

export default function SiteFooter() {
    const currentYear = new Date().getFullYear();
    const socialLinks = SOCIAL_LINKS.filter(link => FOOTER_SOCIAL_IDS.includes(link.id));

    return (
        <footer className="site-footer">
            <div className="site-footer__inner container">
                <div className="site-footer__top">
                    <BrandMark />

                    <ul className="site-footer__links">
                        <li>
                            <a className="site-footer__link" href={PRIVACY_POLICY_PATH}>
                                Política de tratamiento de datos
                            </a>
                        </li>
                        {socialLinks.map(link => (
                            <li key={link.id}>
                                <a className="site-footer__link" href={link.href} target="_blank" rel="noopener">
                                    {link.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="site-footer__bottom">
                    <p className="site-footer__legal">
                        © {currentYear} {BRAND.legalName} ·{' '}
                        <span className="site-footer__nowrap">NIT {BRAND.taxId}</span> · {BRAND.city}
                    </p>
                    <p className="site-footer__credit">
                        Sitio por{' '}
                        {AGENCY_CREDIT.href ? (
                            <a className="site-footer__link" href={AGENCY_CREDIT.href} target="_blank" rel="noopener">
                                {AGENCY_CREDIT.label}
                            </a>
                        ) : AGENCY_CREDIT.label}
                        {' · '}
                        <span className="site-footer__version">{CURRENT_VERSION}</span>
                    </p>
                </div>
            </div>
        </footer>
    );
}
